import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";
import { jsonParse } from "../oidcauthentication/utils";

export const fetchTargetDataA3 = (dispatch, a3ID, tab) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_TARGETSTATE_A3 + a3ID + "&tab=" + tab,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_TARGETSTATE_A3, payload: res.data });
  });
};

export const fetchData = (dispatch, psId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_A3_DATA + psId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_A3_DATA, payload: res.data });
    }
  );
};

export const getApproverHighestTier = (dispatch, site, tierId) => {
  AsyncCallHandler(
    NEXUS_CONST.GET_APPROVER_HIGHEST_TIER + site + "&tierlevel=1",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_APPROVER_HIGHEST_TIER,
      payload: res.data,
    });
  });
};

export const fetchUsers = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_PEOPLE + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_PEOPLE, payload: res.data });
    }
  );
};

export const saveData = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_A3_DATA, NEXUS_CONST.POST, data).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.MANAGE_A3_DATA, payload: res.data });
    }
  );
};

export const manageTargetStateData = (dispatch, data, a3ID, tab) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_TARGET_STATE,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.MANAGE_TARGET_STATE, payload: res.data });
    fetchTargetDataA3(dispatch, a3ID, tab);
  });
};

//Attachments
export const GetAttachmentsDataA3 = (dispatch, a3ID, type) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_ATTACHMENT_A3 + a3ID + "&attachmentType=" + type,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_ATTACHMENT_A3,
      payload: res.data,
    });
  });
};

export const putAttachmentsA3 = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_ATTACHMENT_A3,
    NEXUS_CONST.PUT,
    data
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.MANAGE_ATTACHMENT_A3, payload: res.data });
  });
};

export const deleteAttachmentA3 = (
  dispatch,
  id,
  a3ID,
  type,
  attachmentName,
  tierId,
  activeTab
) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_ATTACHMENT_A3 +
      id +
      "&a3Id=" +
      a3ID +
      "&type=" +
      type +
      "&attachmentName=" +
      attachmentName +
      "&tierId=" +
      tierId +
      "&section=" +
      activeTab,
    NEXUS_CONST.POST
  ).then((res) => {
    GetAttachmentsDataA3(dispatch, a3ID, type);
  });
};

export const fetchTiersList = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_TIER_LIST + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_TIER_LIST, payload: res.data });
    }
  );
};

export const fetchA3GAPGridData = (dispatch, a3ID) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_A3_GAP_DATA + a3ID, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_A3_GAP_DATA, payload: res.data });
    }
  );
};

export const fetchA3GAPSolutionData = (dispatch, a3ID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_A3_GAP_SOLUTION_DATA + a3ID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_A3_GAP_SOLUTION_DATA,
      payload: res.data,
    });
  });
};
export const fetchGapAnalysisData = (dispatch, a3ID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_A3_GAP_ANALYSIS_DATA + a3ID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_A3_GAP_ANALYSIS_DATA,
      payload: res.data,
    });
  });
};

export const manageGapAnalysisData = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_GAP_ANALYSIS_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.MANAGE_GAP_ANALYSIS_DATA,
      payload: res.data,
    });
  });
};

export const fetchRapidExperimentGridDataa3 = (dispatch, a3ID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_EXPERIMENT_A3 + a3ID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_EXPERIMENT_A3, payload: res.data });
  });
};

export const manageEperiments = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_EXPERIMENTS_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.MANAGE_EXPERIMENTS_DATA,
      payload: res.data,
    });
  });
};

export const fetchPeopleList = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.GET_PEOPLE_DATA + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_PEOPLE_DATA, payload: res.data });
    }
  );
};

export const fetchSA3CompletionPlan = (dispatch, a3ID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_A3_COMPLETION_PLAN + a3ID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_A3_COMPLETION_PLAN,
      payload: res.data,
    });
  });
};

export const fetchConfirmedResults = (dispatch, a3ID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_A3_CONFIRMEDRESULTS + a3ID,
    NEXUS_CONST.GET
  ).then((res) => {
    const parsedData = jsonParse(res.data);
    dispatch({
      type: ACTION_TYPES.FETCH_A3_CONFIRMEDRESULTS,
      payload: parsedData,
    });
  });
};

export const fetchConfirmedResultsGraph = (dispatch, a3ID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_A3_CONFIRMEDRESULTS_GRAPH + a3ID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_A3_CONFIRMEDRESULTS_GRAPH,
      payload: res.data,
    });
  });
};

export const manageResults = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_RESULTS_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.MANAGE_RESULTS_DATA,
      payload: res.data,
    });
    fetchConfirmedResults(dispatch, data[0].A3ID);
    fetchConfirmedResultsGraph(dispatch, data[0].A3ID);
  });
};

export const manageFrequencyResults = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_RESULTS_FREQUENCY_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.MANAGE_RESULTS_FREQUENCY_DATA,
      payload: res.data,
    });
    fetchConfirmedResults(dispatch, data.a3ID);
    fetchConfirmedResultsGraph(dispatch, data.a3ID);
    fetchData(dispatch, data.a3ID);
  });
};

export const fetchA3GridData = (dispatch, tierID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_A3_GRID_DATA + tierID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_A3_GRID_DATA, payload: res.data });
  });
};

export const deleteA3GridData = (dispatch, a3ID, tierID,tab) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_A3_GRID_DATA + a3ID + "&tierId=" + tierID+"&section="+tab,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchA3GAPGridData(dispatch, tierID);
  });
};

export const fetchUserPref = (dispatch, props) => {
  AsyncCallHandler(
    "Home/getGridCustomization?tierid" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "USER_PREF_SETTINGS", payload: res.data });
  });
};
export const updateUserPref = (dispatch, data) => {
  AsyncCallHandler("Home/ManageGridCustomData", NEXUS_CONST.POST, data).then(
    (res) => {
      //data saved!
    }
  );
};

export const fetchPrintInfoA3 = (dispatch, id) => {
  AsyncCallHandler("A3/getA3PrintData?id=" + id, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: "FETCH_A3_PRINT_DATA", payload: res.data });
    }
  );
};

export const fetchA3TeamMem = (dispatch, props) => {
  AsyncCallHandler(
    "A3/getA3CompletionPlanOwnerList?" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "A3_TEAM_MEM", payload: res.data });
  });
};
